import { supabase } from '@/lib/supabase';

const createEntity = (tableName) => ({
    filter: async (filters = {}, orderBy = '', limit = null) => {
        let query = supabase.from(tableName).select('*');

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                query = query.eq(key, value);
            }
        });

        if (orderBy) {
            const ascending = !orderBy.startsWith('-');
            const column = ascending ? orderBy : orderBy.substring(1);
            query = query.order(column, { ascending });
        }

        if (limit) {
            query = query.limit(limit);
        }

        const { data, error } = await query;
        if (error) {
            console.error(`Error filtering ${tableName}:`, error);
            return [];
        }
        return data || [];
    },
    create: async (data) => {
        const { data: created, error } = await supabase.from(tableName).insert(data).select().single();
        if (error) throw error;
        return created;
    },
    update: async (id, data) => {
        const { data: updated, error } = await supabase.from(tableName).update(data).eq('id', id).select().single();
        if (error) throw error;
        return updated;
    },
    subscribe: (callback) => {
        const channel = supabase.channel(`public:${tableName}`)
            .on('postgres_changes', { event: '*', schema: 'public', table: tableName }, (payload) => {
                callback({
                    type: payload.eventType.toLowerCase(),
                    data: payload.new || payload.old
                });
            })
            .subscribe();

        return () => supabase.removeChannel(channel);
    },
    list: async () => {
        const { data, error } = await supabase.from(tableName).select('*');
        if (error) return [];
        return data || [];
    }
});

export const base44 = {
    auth: {
        isAuthenticated: async () => {
            const { data: { session } } = await supabase.auth.getSession();
            return !!session;
        },
        me: async () => {
            const { data: { user } } = await supabase.auth.getUser();
            if (!user) return null;
            return {
                ...user,
                email: user.email,
                full_name: user.user_metadata?.full_name || user.email?.split('@')[0],
                role: user.email === 'admin@tecnosys-ups.com' ? 'admin' : (user.user_metadata?.role || 'user')
            };
        },
        redirectToLogin: (redirectUrl) => {
            const currentPath = redirectUrl || window.location.pathname;
            window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
        },
        updateUser: async (attributes) => {
            const { data, error } = await supabase.auth.updateUser(attributes);
            return { data, error };
        },
        logout: async () => {
            await supabase.auth.signOut();
            window.location.href = '/';
        },
        onAuthStateChange: (callback) => {
            const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
                callback(event, session);
            });
            return subscription;
        },
    },
    entities: {
        UPS: createEntity('ups'),
        Riparazione: createEntity('riparazioni'),
        StatoRiparazione: createEntity('stati_riparazione'),
        Documento: createEntity('documenti'),
        ContrattoManutenzione: createEntity('contratti_manutenzione'),
        Notifica: createEntity('notifiche'),
        FAQ: createEntity('faq'),
        RichiestaPreventivo: createEntity('richieste_preventivo'),
        ProdottoUPS: createEntity('prodotti_ups'),
        ArticoloBlog: createEntity('articoli_blog'),
        Utente: createEntity('admin_users_view'),
    },
    integrations: {
        Core: {
            SendEmail: async ({ to, subject, body }) => {
                try {
                    const { data, error } = await supabase.functions.invoke('send-email', {
                        body: { to, subject, body }
                    });

                    if (error) throw error;
                    console.log('Email sent successfully:', data);
                    return true;
                } catch (err) {
                    console.error('Error sending email:', err);
                    return false;
                }
            }
        }
    }
};
